import React, { useState, useEffect } from "react";
import axios from "axios";
import OptimizationReport from "./optimizationReport";
import { get_reports } from "../../config/apiUrls";

function OptimizationReportTable(props) {
  const { userInfo, enableAutoRefresh } = props
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchReportData();
  }, [userInfo]);

  const fetchReportData = _ => {
    setLoading(true)
    // axios.get(`${get_reports}/lakshman@user.com/`).then(response => {
    axios.get(get_reports).then(response => {
      setData(response.data);
      setLoading(false);
      //console.log("fetch", response.data);
    });
  }
  React.useEffect(() => {
    if (enableAutoRefresh) {
      const refreshInterval = 30000;
      const interval = setInterval(() => {
        fetchReportData();
      }, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [enableAutoRefresh]);



  return (
    <div>
      <OptimizationReport data={data} loading={loading} fetchData={fetchReportData} />

    </div>
  );
}

export default OptimizationReportTable;
